import { useState } from "react";
import clsx from 'clsx'
import { DefaultTitle } from "../../../_metronic/layout/components/header/page-title/DefaultTitle";
import { PageTitle, useLayout } from "../../../_metronic/layout/core";
import { IImportar } from "../../interfaces/IImportar";
import ImportarNovoModal from "./ImportarNovoModal";
import Swal from 'sweetalert2';
import VerticalLinearStepper from "./VerticalLinearStepper";

/*Tradução */
import '../../../i18n/config';
import { useTranslation } from 'react-i18next';
const ImportarNovo = () => {
    const { t } = useTranslation();
    const { classes } = useLayout();
    const [showModal, setShowModal] = useState<boolean>(false);
    const [eventoVM, setEventoVM] = useState<IImportar>({} as IImportar);
    const [modalTitle, setModalTitle] = useState<'Empresa'>('Empresa');
    const [formularioCalendario, setFormularioCalendario] = useState<File[]>([]);
    // const [activeStep, setActiveStep] = useState<number>(0);

    // const handleNext = () => {
    //     setActiveStep((prevActiveStep) => prevActiveStep + 1);
    // };

    // const handleBack = () => {
    //     setActiveStep((prevActiveStep) => prevActiveStep - 1);
    // };

    // const handleReset = () => {
    //     setActiveStep(0);
    // };

    async function salvar(empresa: IImportar) {
        toggleModal();
        await Swal.fire({
            text: t('Empresa foi adicionada com sucesso'),
            timer: 4000,
            icon: 'success',
            showConfirmButton: false
        });
    }

    function toggleModal(): void {
        let show = !showModal;

        setShowModal(show);

        if (show === false) {
            setTimeout(() => { setEventoVM({} as IImportar) }, 300)
        }
    }

    return <>
        <PageTitle breadcrumbs={[]}>{t("Importar arquivos")}</PageTitle>
        <div className='toolbar' id='kt_toolbar'>
            <div id='kt_toolbar_container' className={clsx(classes.toolbarContainer.join(' '), 'd-flex flex-stack')}>
                <DefaultTitle />
            </div>
        </div>
        <div className="col-md-12" style={{ display: 'flex' }}>
            <div className="col-md-3">
                <label style={{ fontSize: '14px', color: '#aaa' }}>{t("Razão Social")}</label>
                <h3>LFUTURO DO BRASIL S.A.</h3>
                <label style={{ fontSize: '14px', color: '#aaa' }}>{t('CNPJ')}</label>
                <h3>16.457.056/0001-00</h3>
                <label style={{ fontSize: '14px', color: '#aaa' }}>{t("Regime Tributário")}</label>
                <h3>{t("Simples Nacional")}</h3>

                <ImportarNovoModal salvar={salvar} importar={eventoVM} title={modalTitle} show={showModal} toggleModal={toggleModal} />
            </div>
            <div className="col-md-6">
                <div style={{ display: 'grid' }}>
                    <label htmlFor="file" style={{ fontWeight: 600 }}>{t("NF Serviços Prestados - Dentro do munícipio")}</label>
                    <progress id="file" value="20" max="100" />
                </div>
                <div style={{ overflow: 'auto', maxHeight: '195px', maxWidth: '600px' }}>
                    {
                        formularioCalendario.map(arquivo => {
                            return <div style={{ border: '1px solid #ccc', borderRadius: '3px', margin: '3px 0', padding: '5px', width: '600px' }}>
                                <i className="bi bi-file-earmark-text fa-lg" style={{ color: '#005E96' }}></i>
                                <span className="azul-agriholmes" style={{ fontFamily: 'Cairo', fontSize: '16px' }}> {arquivo?.name}</span>
                                <i className="bi bi-x-circle fa-lg" style={{ float: 'right', margin: '4px 4px 0 0', color: 'black', cursor: 'pointer' }} onClick={() => setFormularioCalendario([...formularioCalendario.filter(x => x !== arquivo)])}></i>
                            </div>
                        })
                    }
                </div>
                <input style={{ display: 'none' }} id="inputFile" type="file" onChange={e => {
                    if (e.target.files !== null && e.target.files.length > 0) {
                        const file = e.target.files[0];
                        setFormularioCalendario(array => [...array, file]);
                    }
                }} />
                <div onClick={() => {
                    const input = document.getElementById("inputFile");
                    input?.click();
                }} className="col-md-12 mt-5" style={{ border: '2px dashed #8E92B8', textAlign: 'center', borderRadius: '10px', cursor: 'pointer', height: '150px', width: "600px", paddingTop: '5px' }}>
                    <div className="dropzone " id="upload" >
                        <div className="mt-5 mb-5">
                            <i className="bi bi-cloud-arrow-up fs-5x azul-agriholmes"></i>
                            <span className="azul-agriholmes" style={{ fontFamily: 'Cairo', fontSize: '26px' }}> <br />{t("Importar NF Serviços Prestados")}</span>
                        </div>
                    </div>
                </div>

                <div style={{ display: 'flex', marginTop: '20px' }}>
                    <button style={{ height: '40px', fontWeight: 800, marginRight: 'auto' }} className='btn btn-sm btn-primario'>{t("RELATÓRIO")}<i style={{ marginLeft: '10px' }} className="icon-lg text-white bi bi-pie-chart"></i></button>
                    <button style={{ height: '40px', color: '#496D93', backgroundColor: 'white', border: '2px solid #496D93', fontWeight: 800, marginRight: '10px' }} className='btn btn-sm'>{t("PULAR")}<i style={{ marginLeft: '10px' }} className="azul-agriholmes bi bi-skip-end"></i></button>
                    <button style={{ height: '40px', fontWeight: 800 }} className='btn btn-sm btn-primario'>{t("CONTINUAR")}<i style={{ marginLeft: '10px' }} className="icon-lg text-white bi bi-arrow-right" /></button>
                </div>
            </div>
            <div className="col-md-3">
                <VerticalLinearStepper activeStep={0} />
            </div>
        </div>
    </>
};


export default ImportarNovo;

